import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Invoices',
    component: () => import('../views/Invoices.vue')
  },
  {
    path: '/customers',
    name: 'Customers',
    component: () => import('../views/Customers.vue')
  },
  {
    path: '/rotationdays',
    name: 'Rotation Days',
    component: () => import('../views/RotationDays.vue')
  },
  {
    path: '/billingcalendar',
    name: 'Billing Calendar',
    component: () => import('../views/BillingCalendar.vue')
  },
  {
    path: '/rotationdayscalendar',
    name: 'Rotation Days Calendar',
    component: () => import('../views/RotationDaysCalendar.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '*',
    name: 'Login',
    component: () => import('../views/Login.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
